export enum SELECTED_GENERATION_OPTION {
  GENERATE_FIRST,
  GENERATE_FOLLOWING,
  GENERATE_OTHER,
}
